import { ColorV2 } from "config/colors";
import { TypographyV2 } from "config/font";
import styled from "styled-components";

type MetricCellProps = {
  label: string;
  muted?: boolean;
  value: string;
};

export const MetricCell = ({
  label,
  muted,
  value,
}: MetricCellProps): JSX.Element => {
  return (
    <Cell>
      <Value $muted={muted}>{value}</Value>
      <Label>{label}</Label>
    </Cell>
  );
};

export const Cell = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 0;
`;

export const Value = styled.span<{ $muted?: boolean }>`
  ${TypographyV2.h5};
  color: ${(props) => (props.$muted ? ColorV2.Blue5 : ColorV2.Blue1)};
  line-height: 1;
`;

export const Label = styled.span`
  ${TypographyV2.s1};
  color: ${ColorV2.Blue4};
`;
